import React from 'react';
import { Check, X } from 'lucide-react';

export default function KeywordBadges({ keywords = [], type = 'found' }) {
	const isFound = type === 'found';
	return (
		<div className="flex flex-wrap gap-2">
			{(keywords || []).map((k, i) => (
				<span
					key={`${k}-${i}`}
					className={`inline-flex items-center gap-1 px-2 py-1 rounded text-xs ${
						isFound ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'
					}`}
					title={typeof k === 'string' ? k : k?.text || ''}
				>
					{isFound ? <Check className="w-3 h-3" /> : <X className="w-3 h-3" />}
					{typeof k === 'string' ? k : k?.text || ''}
				</span>
			))}
		</div>
	);
}


